import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/admin/sftp/organisations")({
    beforeLoad: () => {
        throw redirect({ to: "/developer/sftp/organisations", replace: true });
    },
});
